<script setup>
//region Imports
import {ref, onMounted, reactive} from 'vue'
//endregion
//region Methods
const readData = () => JSON.parse(localStorage.getItem('tc-claim-data'))
const claimData = () => JSON.parse(localStorage.getItem('tc-claims-selected-claim'))
const clickToCancel = () => {
  location.replace('#/claims')
}

//endregion
//region Variables
const data = reactive(readData() ?? {})
const claim = reactive(claimData() ?? {})
const orderNumber = ref(data?.orderNumber)
const updatedAt = new Date (data?.updated_at).toDateString()
let items = reactive(claim?.items?.map(item => {
  item.selected = false
  return item
}))

//endregion
</script>

<template>

  <figure class="w-full h-[180px] lg:h-[340px] overflow-hidden bg-no-repeat bg-right bg-cover"
            style="background-image: url(https://cdn.shopify.com/s/files/1/0067/9532/9609/files/DSC01071.png?v=1713213218);">
      &nbsp;
  </figure>

  <div class="px-[20px] mt-[30px] lg:px-[40px] lg:mt-[37px]">

    <header>

      <h1 class="font-bold text-tc-title font-minionpro text-tc-black tracking-wider"
          v-text="'Resolve Center'"
      ></h1>

      <div class="flex flex-row items-center my-[22px] justify-between">
        <div class="flex gap-4">
        <span class="text-tc-muted-brown text-tc-xl font-avenir">
          Order Number
        </span>
          <span class="text-tc-2xl font-avenir"
                v-text="orderNumber"
          ></span>
        </div>

        <div class="flex flex-row items-center my-[22px] justify-between">

          <span class="text-tc-2xl font-avenir"></span>

        </div>
      </div>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

    </header>

    <main>
      <div class="flex items-center">
        <button type="button"
                @click="clickToCancel()">
          <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 26 26" fill="none">
            <path d="M8 7L2 13L8 19" stroke="black" stroke-width="1.5"/>
          </svg>
        </button>
        <h2 class="text-tc-black font-minionpro font-bold leading-relaxed capitalize text-tc-subtitle">
          Claim
          <span class="ml-4 text-xl text-black font-normal leading-relaxed"
                v-text="claim?.id"
          ></span>
        </h2>
      </div>

      <div class="my-8 flex gap-4 items-center">
        <svg xmlns="http://www.w3.org/2000/svg" width="13" height="13" viewBox="0 0 13 13" fill="none">
          <circle cx="6.5" cy="6.5" r="6" stroke="#CCC2B3"/>
          <path d="M6.5 2V7L8.5 9" stroke="#CCC2B3"/>
        </svg>
        <span class="text-xl text-black font-normal"
              v-text="claim?.status"
        ></span>
        <span class="text-tc-muted-brown text-xl font-normal"
              v-text="updatedAt"
        ></span>
      </div>

      <ul class="grid grid-cols-1 lg:grid-cols-3 gap-[20px] font-avenir">
        <li class="p-2 bg-tc-off-white relative flex"
            v-for="item in items" :key="item?.po_number"
        >
          <img :src="item?.image" alt="Image" class="w-[62px] float-left mr-2">
          <div class="flex flex-col justify-center gap-[7px]">
            <span class="text-tc-2xl font-normal text-black tracking-wider leading-tight">
              {{ item.name.split('/')[0] }}
            </span>
            <span v-if="item?.support"
                  class="text-tc-xl font-normal tracking-wider text-tc-gray"
            >
              {{ item?.suppprt }}
            </span>
          </div>
          <div v-if="item.selected" class="absolute top-0 right-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
              <rect width="17" height="17" fill="#2E1319"/>
              <path d="M4.5 8L7 10.5L12 5.5" stroke="#F9F9F0" stroke-width="2"/>
            </svg>
          </div>
        </li>
      </ul>

      <span class="w-3/4 flex flex-wrap items-baseline text-xl text-black font-normal my-8 gap-2">
        We'll email <span class="text-tc-muted-brown" v-text="data?.customerEmail"></span> with any updates.
      </span>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

      <ul class="grid grid-cols-1 lg:grid-cols-3 gap-4 lg:gap-10 font-avenir" v-if="data != null">
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Order Number</span>
          <span class="text-tc-lg" v-text="orderNumber ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Store Order ID</span>
          <span class="text-tc-lg" v-text="data?.shopifyOrderId ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Order Date</span>
          <span class="text-tc-lg" v-text="data?.orderDate ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Estimated Delivery Date</span>
          <span class="text-tc-lg" v-text="data?.estimatedDeliveryDate ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Email</span>
          <span class="text-tc-lg" v-text="data?.customerEmail ?? 'N/A'"></span>
        </li>
        <li class="flex flex-col gap-1">
          <span class="text-tc-lg text-tc-muted-brown font-medium">Shipped To</span>
          <span class="text-tc-lg" v-text="data?.shippingAddress ?? 'N/A'"></span>
        </li>
      </ul>

      <hr class="w-full h-0.5 bg-tc-off-white-two my-[20px] lg:my-[30px]">

      <h3 class="mb-[12px] flex items-center gap-3">
        <svg xmlns="http://www.w3.org/2000/svg" width="17" height="17" viewBox="0 0 17 17" fill="none">
          <path
              d="M8.053 6.916H9.067V13H8.053V6.916ZM7.819 4.537C7.819 4.33767 7.88833 4.16433 8.027 4.017C8.17433 3.86967 8.352 3.796 8.56 3.796C8.768 3.796 8.94133 3.86967 9.08 4.017C9.22733 4.16433 9.301 4.33767 9.301 4.537C9.301 4.75367 9.23167 4.93133 9.093 5.07C8.95433 5.20867 8.77667 5.278 8.56 5.278C8.34333 5.278 8.16567 5.20867 8.027 5.07C7.88833 4.93133 7.819 4.75367 7.819 4.537Z"
              fill="#2E1319"/>
          <rect x="0.5" y="0.5" width="16" height="16" rx="8" stroke="#2E1319"/>
        </svg>
        <span class="text-tc-lg text-tc-muted-brown font-medium">Support</span>
      </h3>

      <ul class="grid grid-cols-1 gap-[12px] lg:mb-[30px]">
        <li><a href="https://help.trescolori.com" class="text-tc-lg underline" target="_blank">View Help Center</a></li>
        <li><a href="mailto:info@trescolori.com" class="text-tc-lg underline" target="_blank">info@trescolori.com</a>
        </li>
      </ul>

    </main>

  </div>
</template>